/**
 * contiene la información para el manejo de documentos.
 */
export const defaultDocumentos = () => {
        return {
            empresa: '',
            treeVisible: false,
            Informationtree: [],
            nodeActiveId: null,
            node: {
                id: '',
                text: '',
                value: '',
                icon: '',
                activo: '',
                opened: true,
                selected: false,
                disabled: false,
                loading: false,
                type: '', //{folder|file}
                children: [],
                dragDisabled: true,
                dropDisabled: true,
                url: ''
            },
            modifyNode: false,
            nodeToModify: {},

            descripcion: null,
            adjunto: null,
            activo: true,
            padre_id: null,
            tipo: null,
            empresaId: null,

            descripcionCarpe: null,
            activoCarpe: true,
            editarCarpe: false,
            urlDescarga: '',
            adjuntar: false,
        }
    }
    /* ,

    export const defaultEmpresas = () => {
        return {
            empresas: [],
        }
    } */

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedDocumentos: defaultDocumentos(),
    treeInfo: [],
    btnAdjuntar: true,
    btnCarpeta: true,
    urlDescarga: '',
    documents: [],
    selectedDocument: null
}
